import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const includedInHouseholdOptions = [
  {
    id: 'centralHeatingAndAirConditioning',
    label: 'Central heating and air conditioning',
    checked: false,
  },
  { id: 'naturalGasHeating', label: 'Natural gas heating', checked: false },
  { id: 'poolOrHotTub', label: 'Pool or hot tub', checked: false },
  { id: 'smartThermostat', label: 'Smart thermostat', checked: false },
  {
    id: 'homeAutomation',
    label: 'Home automation for energy management',
    checked: false,
  },
  { id: 'electricVehicle', label: 'Electric vehicle', checked: false },
  { id: 'solarPanels', label: 'Solar panels', checked: false },
]

export const householdIncludes = {
  component: QuestionWrapper,
  componentProps: {
    title: 'Does your home have any of the following?',
    label: 'Energy consumption',
    subtitle: 'Select all that apply.',
    options: includedInHouseholdOptions,
    formValue: 'householdIncludes',
    tooltip:
      'These factors can significantly affect your energy usage. We’ll keep this in mind when recommending plans. ',
    canSkip: true,
    tracking: {
      stepName: 'Household Includes',
      deepStepNumber: 4,
      quickStepNumber: 4,
      deepStepId: '4',
      quickStepId: '4',
      fieldName: 'household_features',
    },
  },
  name: 'householdIncludesCheckboxGroup',
  schema: z.object({
    householdIncludes: z.array(z.string()).optional(),
  }),
}
